import { TABLE_TYPES } from './global';

export const tableWidthMap = {
  [TABLE_TYPES.OPEN_ORDERS]: {
    side: 120,
    size: 100,
    filledAmount: 100,
    limitPrice: 115,
    margin: 110,
    leverage: 95,
    openOrderCreateTime: 105,
    action: 90,
    checkboxCol: 40,
  },
};
